export const LogoShade = Object.freeze({
  DARK: 'Dark',
  LIGHT: 'Light',
  WHITE: 'White',
})
